<template>
  <div>
    <Form :description-title="'Faça o cadastro de novas unidades'">
      <Create
        @click="newUnidade()"
        :icon="PhBuildingApartment"
        :label="'Cadastrar'"
      />
    </Form>
  </div>
</template>

<script setup>
import Create from "@/components/Buttons/Create.vue";
import Form from "../components/UnidadeForm.vue";
import RcdService from "../service/rcd.service";
import * as yup from "@/validator";
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField,
} from "@/helpers/formFieldsHandler";
import { PhBuildingApartment } from "@phosphor-icons/vue";
import { showToast as toast } from "@/helpers/UseToasts";
import { dataRcd } from "../store";
import { storeApp } from "@/store";

const store = dataRcd.state;
const appStore = storeApp.state;

const schema = yup.object().shape({
  unidadeForm: yup.object().shape({
    unidade: yup.string().required("Informe a unidade").label("Unidade"),
    cidade: yup
      .string()
      .required("Informe a cidade da unidade")
      .label("Cidade"),
    estado: yup.string().required("Estado da unidade").label("Estado"),
  }),
});

async function newUnidade() {
  appStore.loading = true;

  cleanAllFormFields();

  const validate = await validateFormField(schema, store);

  if (validate && validate.length > 0) {
    setFormFieldsError(validate);
    appStore.loading = false;
    return;
  }

  await RcdService.registerUnidade(store.unidadeForm)
    .then((res) => {
      appStore.loading = false;

      if (res.data.success) {
        dataRcd.dispatch("setUnidades", res.data.unidades);

        return toast("Sucesso", "Nova unidade cadastrada", "success");
      }
    })
    .catch((err) => {
      appStore.loading = false;

      if (err?.response?.data?.error) {
        return toast("Aviso", err.response.data.message, "error");
      }

      return toast("Aviso", "Algo deu errado ao cadastrar unidade", "error");
    });
}
</script>
